// Default forbidden keys are the universal PII set from the upstream spec.
// Module-specific keys (e.g. clinical fields) come via `additionalForbiddenKeys`
// at `initObservability()` time — see the call in `main.ts` / `ai-assistant-plugin.ts`.
const DEFAULT_FORBIDDEN_KEYS = new Set([
  "email",
  "password",
  "token",
  "phone",
  "address",
]);

let allForbiddenKeys: Set<string> = DEFAULT_FORBIDDEN_KEYS;

export function configureForbiddenKeys(additionalKeys: string[] = []): void {
  allForbiddenKeys = new Set([
    ...DEFAULT_FORBIDDEN_KEYS,
    ...additionalKeys.map((k) => k.toLowerCase()),
  ]);
}

function stripPiiInternal(
  obj: Record<string, unknown>,
  visited: WeakSet<object>
): Record<string, unknown> {
  const result: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(obj)) {
    if (allForbiddenKeys.has(key.toLowerCase())) continue;

    if (Array.isArray(value)) {
      result[key] = value.map((item) => {
        if (item && typeof item === "object" && !Array.isArray(item)) {
          if (item instanceof Error) return item;
          if (visited.has(item)) return "[Circular]";
          visited.add(item);
          const stripped = stripPiiInternal(item as Record<string, unknown>, visited);
          visited.delete(item);
          return stripped;
        }
        return item;
      });
    } else if (value && typeof value === "object") {
      if (value instanceof Error) {
        result[key] = value;
      } else if (visited.has(value)) {
        result[key] = "[Circular]";
      } else {
        visited.add(value);
        result[key] = stripPiiInternal(value as Record<string, unknown>, visited);
        visited.delete(value);
      }
    } else {
      result[key] = value;
    }
  }
  return result;
}

export function stripPii(
  obj: Record<string, unknown> | undefined
): Record<string, unknown> | undefined {
  if (!obj || typeof obj !== "object") return obj;
  return stripPiiInternal(obj, new WeakSet());
}
